import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomFieldService } from 'api-services/custom-field.service';

import { ManageField } from './../../../models/custom-fields/manage-field.model';
import { EntityType } from './../../../models/custom-fields/entity-type.enum';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { tenantTypeCap } from 'shared/constant';
import { Location } from '@angular/common';

@Component({
  selector: 'app-manage-custom-fields',
  templateUrl: './manage-custom-fields.component.html',
  styleUrls: ['./manage-custom-fields.component.css']
})
export class ManageCustomFieldsComponent implements OnInit {
  @Input() entityType: EntityType = EntityType.Producer;

  @Input() entityId: number = null;

  @Output() showManage: EventEmitter<string> = new EventEmitter<string>();
  activeTab = 'manage-custom-fields';

  customFieldList: ManageField[] = [];

  archivedCustomFieldList: ManageField[] = [];

  isCustomFieldEdit = false;

  selectedField: ManageField = null;
  tabActive = "#Producer";
  activeList: boolean = false;
  archivedActiveList: boolean = false;
  isDataReload: boolean = false;
  tenantTypeCap = tenantTypeCap;
  tenantTypeId = localStorage['tenantTypeId'];
  isArchived: boolean = false;
  isClicked: boolean = false;

  constructor(
    private customFieldService: CustomFieldService,
    private cdr: ChangeDetectorRef,
    private location: Location
  ) { }

  ngOnInit(): void {
    window.scroll(0, 0);

    if (localStorage.hasOwnProperty('fields')) {
      var fields = localStorage['fields'].split(',');
      
      switch (Number(fields[1])) {
        case 1:
          this.tabActive = '#Producer';
          break;
        case 2:
          this.tabActive = '#Firm';
          break;
        case 3:
          this.tabActive = '#License';
          break;

        case 4:
          this.tabActive = '#Appointment';
          break;

        default:
          this.tabActive = '#Producer';
      }
    }

     this.entityType = EntityType[this.tabActive.split('#')[1]];
    this.getManageFields();

  }

  getManageFields(): void {
   

    this.customFieldService.getManageFields({

      entityType: this.entityType,

      isArchived: this.isArchived

    }).subscribe(result => {
      this.isCustomFieldEdit = false;
      this.selectedField = null;

      result.forEach(field => {

        field.isEditable = false;

        field.options = field.items
          ? JSON.parse(field.items)
          : [];

      });

      if (this.isArchived) {

        this.archivedCustomFieldList = result;
        this.archivedCustomFieldList?.length > 0 ? this.editCustomField(this.archivedCustomFieldList[0]) : '';
        this.archivedActiveList = true;

      }
      else {

        this.customFieldList = result;

        // this.customFieldList?.length > 0 ? this.editCustomField(this.customFieldList[0]) : '';
        this.activeList = true;

      }

    });

  }



drop(event: CdkDragDrop<ManageField[]>) {
    if (event.previousContainer === event.container) {      
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );      
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }   
    
    this.updateOrdinalPosition(event.container.data); 
    this.cdr.detectChanges();   
    
  }



  updateOrdinalPosition(data?: ManageField[]) {    
    if(data)
    {
      data.forEach((item, index) => {
        item.ordinalPosition = index + 1;
      });
      this.customFieldList = data;
      this.isDataReload = true;
      this.customFieldService.updateFieldOrdinalPosition(this.customFieldList)
        .subscribe();
      
    }
     
  }
  
  trackByFn(index: number, item: ManageField) {

    return item.fieldId;

  }


  // closePopup(){
  //   this.activeModal.close(this.isDataReload);
  // }

  editCustomField(customField: ManageField): void {

    // if(this.isArchived){
    //   return;
    // }

    this.isCustomFieldEdit = true;
    // this.scrolltoId();
    this.selectedField = {

      ...customField

    };

  }

  scrolltoId() {
    setTimeout(() => {
      document.getElementById('active')?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }, 0);
  }

  updateView(event){
    this.isCustomFieldEdit = event;
    this.selectedField = null;
  }

  reloadManageFields(): void {

    this.isCustomFieldEdit = false;

    this.selectedField = null;

    this.getManageFields();

    // this.getManageFields(true);

  }

  getSelectedTab(event){
    this.isCustomFieldEdit = false;
    this.tabActive = event.srcElement.hash != undefined? event.srcElement.hash : this.tabActive;
    this.entityType = EntityType[this.tabActive.split('#')[1]];
    this.getManageFields();
  }

  targetLink(tab, isBackArrow: boolean = false) {
    if(localStorage.hasOwnProperty('fields') && isBackArrow){
      this.location.back()
    }else{
      this.showManage.emit(tab);
    }
  }

  copyText(text){
    this.isClicked = true;
    let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = text;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }

  ngOnDestroy(){
    localStorage.removeItem('fields');
  }

}
